import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDebounce } from '../../../../hooks/useDebounce'
import { Switch } from '../../../../components/inputs/Switch'

type ToggleCellProps = {
  value: boolean | undefined
  onChange?: (v: boolean | undefined) => void
} & CellPropsBase
export const ToggleCell = ({
  label,
  help,
  cellWidth,
  value,
  onChange: _onChange,
  editable = true,
  required = false,
  edited,
  validationErrors,
}: ToggleCellProps) => {
  const changed = useRef(false)
  const [checked, setChecked] = useState(value)
  const onChange = useCallback((_, newValue: boolean) => {
    changed.current = true
    setChecked(newValue)
  }, [])
  const debouncedChecked = useDebounce(checked, 300)
  useEffect(() => {
    changed.current = false
    setChecked(value)
  }, [value])
  useEffect(() => {
    _onChange && changed.current && _onChange(debouncedChecked)
  }, [_onChange, debouncedChecked])

  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <Switch checked={checked} onChange={onChange} disabled={!editable} />
      </CellValueArea>
    </FormCell>
  )
}
